import React, { useState } from 'react';
import Input from 'b2b-ui-components-lib/lib/components/input';
import Select from 'b2b-ui-components-lib/lib/components/select';
import Button from 'b2b-ui-components-lib/lib/components/button';
import './tmoModal.scss';
import { CustomTable } from 'common/components/table/table';
import TableLoader from '../organisms/addressProcessAOI/loader/table-loader';
import { generateToken, getOrders } from '../../services';
import appConfig from '../../../../../config/config';
// import getOrders from 'home/view/manage-feasibility/services'

export const TmoModal = (props) => {
  let {
    setParameters,
    handleCreateNewRequest,
    onCellClickHandler,
    showLoader,
    tableData,
    totalPages,
    totalSitesProcessed,
    onTableStateChange,
    onClearFilter,
    paginationLength,
    headers,
    setTableData,
    setShowLoader,
    setTotalSitesProcessed,
    setTotalPages,
    getRowData,
    fetchOrders,
    pageLength,
    setPageLength,
    numberOfRowsToShow,
    setNumberOfRowsToShow
  } = props;

  const [selectedOption, setSelectedOption] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [inputField, setInputField] = useState(true);
  const [inputPlaceHolder, setInputPlaceHolder] = useState('Please Select a filter');
  const [showSelectForOrderStatus, setShowSelectForOrderStatus] = useState(false);
  const [orderStatusSelectedOption, setOrderStatusSelectedOption] = useState({});
  // const [numberOfRowsToShow, setNumberOfRowsToShow] = useState(10);

  const filterOptions = [
    { displayName: 'Company Name', key: 'companyName' },
    { displayName: 'Account Number', key: 'accountNumber' },
    { displayName: 'Order Status', key: 'orderStatus' }
    // { displayName: "Order Submitted", key: "ORDER_SUBMITTED" },
  ];

  const inputFieldText = [
    // if number of filters are more use this approach to loop through the keys and display the name
    { displayName: 'Please Select a filter', key: 'default' },
    { displayName: 'Enter Account Name here', key: 'accountName' },
    { displayName: 'Enter Account Number here', key: 'acountNumber' }
  ];

  const orderStatusOptions = [
    { displayName: 'Feasibility Pending', key: 'FEASIBILITY_PENDING' },
    { displayName: 'Feasibility Completed', key: 'FEASIBILITY_COMPLETED' },
    { displayName: 'Order In Progress', key: 'ORDER_IN_PROGRESS' },
    { displayName: 'Order Validation Pending', key: 'OV_PENDING' }
  ];

  const clickBuyNowBtn = () => {
    handleCreateNewRequest(true);
  };

  // const paramsForApiCall = {COMPANY_NAME: 'companyName', ACCOUNT_NUMBER: 'AccountNumber', ORDER_STATUS: 'orderStatus' }

  const getOrderWithFilters = async (params = {}, page = 1, size = 10) => {
    setNumberOfRowsToShow(10);
    try {
      setShowLoader(true);
      const config = {
        // baseURL:appConfig.apiBaseUrl,
        headers: {
          token: localStorage.getItem('accessToken')
        }
      };
      const { res, err } = await getOrders(params, config);

      if (res) {
        const {
          status,
          data: { content, pageNumber, pageSize, totalElement, totalPages }
        } = res;
        if (res === null || Object.keys(res).length === 0 || (Array.isArray(content) && content.length === 0)) {
          // handleCreateNewRequest();
          setTableData([]);
          setTotalPages(0);
          setTotalSitesProcessed(0);
          setShowLoader(false);
        } else if (status === 200) {
          const tableRowList = [];
          setShowLoader(false);
          setTotalSitesProcessed(totalElement);
          setTotalPages(totalPages);

          if (content && content.length > 0) {
            const indexing = (page * 10) / size - 1;
            let effectiveIndex = 0;
            if (indexing >= 0) {
              effectiveIndex = Math.ceil(indexing);
            } else {
              effectiveIndex = Math.floor(indexing);
            }
            //  effectiveIndex = (page*10/size) -1 ;
            const effectiveSize = effectiveIndex + size;

            content
              // .filter((item) => item.numberOfSites > 0)
              .filter((_item, index) => index >= effectiveIndex && index < effectiveSize)
              .forEach((rowItem) => {
                const rowData = getRowData(rowItem);
                tableRowList.push(rowData);
              });
          }

          setPageLength(Math.ceil(totalElement / size));
          // if (totalElement % size === 0) {
          //   // paginationLength = totalElement/pageSize;
          //   setPageLength(totalElement / size);
          // } else {
          //   // paginationLength = totalElement/pageSize + 1;
          //   setPageLength(totalElement / size + 1);
          // }
          setTableData(tableRowList);
        }
      }
      // else if(totalElement === 0)
      // {
      //   setShowLoader(false);
      // }
      else {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setShowLoader(false);
        setTableData([]);
        setTotalPages(0);
        setTotalSitesProcessed(0);
        setShowLoader(false);
        // handleCreateNewRequest();

        // setToast(true, errorMsg, ERROR_TOAST);
        throw new Error(errorMsg);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const changeFilterHandler = (value) => {
    setSelectedOption(value);
    setOrderStatusSelectedOption({});
    if (value.key === 'companyName') {
      setInputPlaceHolder('Enter Company Name here');
      setShowSelectForOrderStatus(false);
    } else if (value.key === 'accountNumber') {
      setInputPlaceHolder('Enter Account Number here');
      setShowSelectForOrderStatus(false);
    } else if (value.key == 'orderStatus') {
      setShowSelectForOrderStatus(true);
    }
    setSearchQuery('');
    setInputField(false);
    const params = {
      // token: localStorage.getItem('accessToken'),
      productName: 'DSL',
      source: 'SELF_CARE',
      size: 10,
      page: 0
      // orderStatus : value?.key,
    };

    // console.log(params);

    // getOrderWithFilters(params)
  };

  const onChangeStatusHandler = (value) => {
    setOrderStatusSelectedOption(value);
    let params = {
      // token: localStorage.getItem('accessToken'),
      productName: 'DSL',
      source: 'SELF_CARE',
      size: 10,
      page: 0
    };
    params = {
      ...params,
      orderStatus: value.key
    };
    setParameters(params);
    getOrderWithFilters(params);
  };

  const handleInputFieldChange = (value) => {
    // console.log(value);
    setSearchQuery(value);
    const selectOptionForFilters = selectedOption?.key;
    let params = {
      // token: localStorage.getItem('accessToken'),
      productName: 'DSL',
      source: 'SELF_CARE',
      size: 10,
      page: 0
      // selectOptionForFilters : value
      // orderStatus : selectedOption ? selectedOption?.key : '',
    };

    // if(selectedOption && selectedOption?.key) {
    //   params = {
    //     ...params,
    //     orderStatus: selectedOption?.key
    //   }
    // }
    if (selectedOption && selectedOption?.key) {
      const selectedFilter = selectedOption?.key;
      if (selectedFilter === 'companyName') {
        params = {
          ...params,
          companyName: value
        };
      } else if (selectedFilter === 'accountNumber') {
        params = {
          ...params,
          accountNumber: value
        };
      }
    }
    setParameters(params);
    // onTableStateChange()
    if (value.length >= 3 || value.length === 0) {
      getOrderWithFilters(params);
    }
    // ;
    // fetchOrders();
  };

  return (
    <div className="modal_full_screen">
      {/* <span onClick={[]} className="cross_icon"></span> */}
      <div className="modal_content">
        <aside className="left_section">
          <h3 className="modal_title">AOI Orders</h3>
        </aside>
        <div className="right_section">
          <div className="modal_body">
            <div className="btn_alignment">
              <div class="searchbox compact ">
                <Select onChange={changeFilterHandler} options={filterOptions} value={selectedOption} />
                {showSelectForOrderStatus && (
                  <div className="order-status-select">
                    <Select onChange={onChangeStatusHandler} options={orderStatusOptions} value={orderStatusSelectedOption} />
                  </div>
                )}
                <div class="searchwrap">
                  <div class="inputContainer input_with_info">
                    {!showSelectForOrderStatus && (
                      <>
                        <Input placeholder={inputPlaceHolder} required class="input" value={searchQuery} onChange={handleInputFieldChange} disabled={inputField} />
                        <i class="material-icons searchiconbox">search</i>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <div className="party_selector_filter_container"></div>
            </div>

            <div className="total_account">
              {totalSitesProcessed ? (
                <div class="totalcount">
                  <span>{totalSitesProcessed}</span> Total Orders
                  <span
                    className="buy_now_box"
                    style={{ textAlign: 'right', display: 'block', marginTop: '-20px', color: '#e44444', cursor: 'pointer', fontSize: '16px', fontWeight: '600' }}
                  >
                    <Button className="buy_now b2b-lib-activebtn" onClick={clickBuyNowBtn}>
                      New Request
                    </Button>
                  </span>
                </div>
              ) : (
                !showLoader && (
                  <div>
                    <div class="totalcount">
                      <span
                        className="buy_now_box"
                        style={{ textAlign: 'right', display: 'block', marginTop: '-20px', color: '#e44444', cursor: 'pointer', fontSize: '16px', fontWeight: '600' }}
                      >
                        <Button className="buy_now b2b-lib-activebtn" onClick={clickBuyNowBtn}>
                          New Request
                        </Button>
                      </span>
                    </div>
                  </div>
                )
              )}

              <div className="parties_list">
                <CustomTable
                  hideClearFilter
                  loader={<TableLoader />}
                  renderHeaderSection={() => {}}
                  showLoader={showLoader}
                  headers={headers}
                  contents={tableData}
                  onCellClickHandler={onCellClickHandler}
                  totalPages={totalPages - 1}
                  totalRecords={totalSitesProcessed}
                  onChange={onTableStateChange}
                  showSearch={false}
                  multipleSort={false}
                  onClearFilter={onClearFilter}
                  paginationLength={pageLength}
                  renderMessage={() => {}}
                  onSortChange={() => {}}
                  onPageChange={() => {}}
                  numberOfRowsToShow={numberOfRowsToShow}
                />
              </div>
            </div>
          </div>
          {/* <div className="modal_footer">
            <Button displayName="Select Account" />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TmoModal;
